import React, { useState, useEffect } from "react";
import styles from "../user_role_modal/user_role_modal.module.css";
import LoadingButton from "@mui/lab/LoadingButton";
import { Dialog, Checkbox } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export default function UserSiteModal(props) {
  const {
    activeSites,
    activeRegions,
    activeSiteGroups,
    siteList,
    siteSelectIsOpen,
    setSiteSelectIsOpen,
    updateParent,
    user,
    selectedRoleId,
    regionList,
    siteGroupList,
    roleName,
    currentLoggedInUserHasRegionAccess,
  } = props;

  const [access_type = "site", setAccessType] = useState(props.accessByRegion || false);

  useEffect(() => {
    setSites(activeSites.map((s) => s.id));
    setRegions(activeRegions.map((r) => r.id));
    setAccessType(props.access_type || false);
  }, [selectedRoleId]);

  const [sites, setSites] = useState(activeSites?.map((r) => r.id) || []);
  const [regions, setRegions] = useState(activeRegions?.map((r) => r.id) || []);
  const [siteGroups, setSiteGroups] = useState(activeSiteGroups?.map((r) => r.id) || []);

  const updateSites = (site_id, checked) => {
    let updated_sites = [...sites];
    if (checked) {
      updated_sites.push(site_id);
    } else {
      updated_sites = updated_sites.filter((id) => id !== site_id);
    }
    setSites(updated_sites);
  };

  const updateRegions = (region_id, checked) => {
    let updated_regions = [...regions];
    if (checked) {
      updated_regions.push(region_id);
    } else {
      updated_regions = updated_regions.filter((id) => id !== region_id);
    }
    setRegions(updated_regions);
  };

  const updateSiteGroups = (group_id, checked) => {
    let updated_site_groups = [...siteGroups];
    if (checked) {
      updated_site_groups.push(group_id);
    } else {
      updated_site_groups = updated_site_groups.filter((id) => id !== group_id);
    }
    setSiteGroups(updated_site_groups);
  };

  return (
    <Dialog open={siteSelectIsOpen} onClose={() => setSiteSelectIsOpen(false)}>
      <div className={styles.dialog_wrapper}>
        <div className={styles.roles_dialog_title}>
          <strong>
            Site Access: {user.first_name} {user.last_name}
          </strong>
        </div>
        <div className={styles.roles_dialog_title}>
          <strong>For role: {roleName}</strong>
        </div>
        <div className={styles.select_wrapper}>
          Site Access Type
          <Select
            value={access_type}
            sx={{
              fontSize: 14,
              width: 125,
              height: 30,
              padding: 0,
              alignSelf: "center",
            }}
            onChange={(e) => setAccessType(e.target.value)}
          >
            {["site", "region", "site_group"].map((o) => (
              <MenuItem key={o} value={o}>
                {o}
              </MenuItem>
            ))}
          </Select>
        </div>

        {access_type === "site" ? (
          <div className={styles.role_wrapper}>
            {siteList.map((site) => (
              <div className={styles.role_row} onClick={() => updateSites(site.id, !sites.includes(site.id))}>
                <Checkbox key={site.id} checked={sites.includes(site.id)} className={styles.checkbox} />
                <div>
                  {site.name} {` (${site.code})`}
                </div>
              </div>
            ))}
          </div>
        ) : null}
        {access_type === "region" ? (
          <div className={styles.role_wrapper}>
            {regionList.map((region) => (
              <div className={styles.role_row} onClick={() => updateRegions(region.id, !regions.includes(region.id))}>
                <Checkbox key={region.id} checked={regions.includes(region.id)} className={styles.checkbox} />
                <div>
                  {region.name} {` (${region.code})`}
                </div>
              </div>
            ))}
          </div>
        ) : null}
        {access_type === "site_group" ? (
          <div className={styles.role_wrapper}>
            {siteGroupList?.map((group) => (
              <div
                className={styles.role_row}
                onClick={() => updateSiteGroups(group.id, !siteGroups.includes(group.id))}
              >
                <Checkbox key={group.id} checked={siteGroups.includes(group.id)} className={group.checkbox} />
                <div>{group.name}</div>
              </div>
            ))}
          </div>
        ) : null}

        <div className={styles.dialog_button_wrapper}>
          <LoadingButton
            variant="contained"
            loading={false}
            onClick={() => {
              updateParent({ access_type, sites, regions, siteGroups });
              setSiteSelectIsOpen(false);
            }}
          >
            UPDATE
          </LoadingButton>

          <LoadingButton
            variant="standard"
            loading={false}
            onClick={() => {
              setSiteSelectIsOpen(false);
            }}
          >
            CANCEL
          </LoadingButton>
        </div>
      </div>
    </Dialog>
  );
}
